import { select, selectAll } from 'helpers/dom'

const selectors = {
  CAROUSEL_SWIPER_SELECTOR: 'js-carousel-swiper',
  CAROUSEL_SWIPER_PREV_SELECTOR: '.js-carousel-prev',
  CAROUSEL_SWIPER_NEXT_SELECTOR: '.js-carousel-next',
  PAGINATION_SELECTOR: '.js-carousel-pagination',
  SCROLL_BAR_SELECTOR: '.js-carousel-scrollbar'
}

class SwiperInstance {
  constructor(element, options, config) {
    this.element = element
    this.selector = element.getAttribute('data-selector') || selectors.CAROUSEL_SWIPER_SELECTOR
    this.type = element.getAttribute('data-type') || null
    this.swiper = null
    this.setOptions(options || {}, config)
    this.initCarousel()
  }

  setOptions(options, config) {
    const { navigation, pagination, scrollbar } = options || {}

    const navEl = {
      prevEl: select(selectors.CAROUSEL_SWIPER_PREV_SELECTOR, this.element),
      nextEl: select(selectors.CAROUSEL_SWIPER_NEXT_SELECTOR, this.element)
    }

    const paginationEl = select(selectors.PAGINATION_SELECTOR, this.element)
    const scrollbarEl = select(selectors.SCROLL_BAR_SELECTOR, this.element)

    let thumbnail = {}

    if (config.thumbnail) {
      const thumbnailEl = select(config.thumbnail)

      thumbnail = {
        thumbs: {
          swiper: thumbnailEl,
          multipleActiveThumbs: false
        }
      }
    }

    this.options = {
      ...options,
      navigation: config.navigation && { ...navigation, ...navEl },
      pagination: config.pagination && { ...pagination, el: paginationEl },
      scrollbar: config.scrollbar && { ...scrollbar, el: scrollbarEl },
      direction: options.direction || 'horizontal',
      lazy: options.lazy || true,
      zoom: config.zoom || false,
      keyboard: {
        enabled: config.keyboard || false,
        onlyInViewport: config.onlyInViewport || true
      },
      ...thumbnail
    }
  }

  initCarousel() {
    setTimeout(() => {
      if (this.type === 'native') {
        const checkSelectorItems = selectAll(`.${this.selector}`)

        if (!checkSelectorItems.length) {
          return
        }

        if (checkSelectorItems.length > 1) {
          // eslint-disable-next-line no-console
          console.error('Swiper: Multiple instances of the same selector are not supported', checkSelectorItems)

          // return
        }

        // this.swiper = new Swiper(`.${this.selector}`, this.options)
      } else {
        this.swiper = select(`.${this.selector}`, this.element)

        if (!this.swiper || !this.swiper?.initialize) return
        Object.assign(this.swiper, this.options)
        this.swiper.initialize()
      }
    }, 500)
  }
}

export default SwiperInstance
